import React from 'react';
import BaseView from './base-view.component';
import BaseCreate from './base-create.component';
import BaseEdit from './base-edit.component';
import BaseDelete from './base-delete.component';

interface IProps { 
    history?: any;
    id?: number;
    copyId?: number;
    caption?: string;
    captionColor?: any;
    buttonCaption?: string;
    successCaption?: string;
    captionThin?: boolean;
    endPoint?: string;
    endPointFilter?: string;
    model: any;
    datarow: any;
    datarowMedia?: any;
    validations?: any;
    onLoad?: (data: any) => void;
    onError?: (data: any) => void;
    onSaveBefore?: () => void;
    onSave?: (data: any) => void;
    save?: boolean;
    delete?: boolean;
    buttonOnBottom?: boolean;
    cardColor?: any;
    cardGradientColor?: any;
    disableAutoBack?: boolean;
    disableBackButton?: boolean;
    disableCard?: boolean;
    children?: React.ReactNode;
}


interface IState {
    datarow: any;
    errors: any;
    isLoad: boolean;
}

export default class BaseCreateEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: this.props.model.defaultValue(),
            errors: null,
            isLoad: false,
        }
    }

    private onLoad = (data: any) => {
        if (data) {
            this.props.onLoad?.(data);
            this.setState({datarow: data, isLoad: true});
        }
    }

    private onLoadCopy = (data: any) => {
        if (data) { 
            data.id = 0;
            this.props.onLoad?.(data);
            this.setState({datarow: data});
        }
    }

    private onError = (data: any) => {
        this.props.onError?.(data);
        this.setState({errors: data});
    }

    private onSaveBefore = async() => {
        await this.props.onSaveBefore?.();
    }

    private onSave = (data: any) => {
            this.props.onSave?.(data);
            this.setState({ datarow: {id: data?.id}, isLoad: false});
    }

    private onDelete = (data: any) => {
        this.setState({ datarow: {...this.state.datarow, id: 0}})
    }
    
    render() {
        return (
        <BaseView history={this.props.history} id={this.props.id} caption={this.props.caption} captionColor={this.props.captionColor} captionThin={this.props.captionThin}
            endPointFilter={this.props.endPointFilter} model={this.props.model} onLoad={this.onLoad} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>

            {this.state.isLoad && !this.state.datarow.id?
                <>
                {!!this.props.copyId &&
                    <BaseView id={this.props.copyId} caption=' '
                        model={this.props.model} onLoad={this.onLoadCopy} disableBackButton disableCard/>
                }
                <BaseCreate caption=' ' buttonCaption={this.props.buttonCaption} successCaption={this.props.successCaption} cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} 
                    model={this.props.model} datarow={this.props.datarow} datarowMedia={this.props.datarowMedia} validations={this.props.validations} save={this.props.save} onError={this.onError} onSave={this.onSave} onSaveBefore={this.onSaveBefore} buttonOnBottom={this.props.buttonOnBottom} disableAutoBack disableBackButton disableCard>
                    {this.props.children}
                </BaseCreate>
                </>
            :
                <BaseEdit id={this.state.datarow.id} caption=' ' buttonCaption={this.props.buttonCaption} successCaption={this.props.successCaption} cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} 
                    model={this.props.model} datarow={this.props.datarow} datarowMedia={this.props.datarowMedia} validations={this.props.validations} save={this.props.save} onError={this.onError} onSave={this.onSave} onSaveBefore={this.onSaveBefore} buttonOnBottom={this.props.buttonOnBottom} disableAutoBack disableBackButton disableCard>                
                    {this.props.children}
                </BaseEdit>
            }
            
            <BaseDelete id={this.state.datarow.id} caption=' ' buttonCaption=' ' model={this.props.model} delete={this.state.datarow.id > 0 && this.props.delete} onDelete={this.onDelete} disableAutoBack disableBackButton />

        </BaseView>
        );
    }
}